import 'css-chunksrc/client/pages/documentsPage/documentsPage/preview/zipRenderer/nodes/node/styles.scss';export default {
  "node": "_node_h5hnn_1",
  "iconBox": "_iconBox_h5hnn_8",
  "icon": "_icon_h5hnn_8",
  "name": "_name_h5hnn_20"
};